import { Component, OnInit, HostListener, Output, EventEmitter, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import {
    trigger,
    transition,
    style,
    animate,
    state,
} from '@angular/animations';

@Component({
    selector: 'app-product-steps',
    standalone: true,
    imports: [CommonModule, TranslateModule],
    templateUrl: './product-steps.component.html',
    styleUrl: './product-steps.component.scss',
    animations: [
        trigger('slideAnimation', [
            // Slide in from right
            transition(':enter', [
                style({ transform: 'translateX(100%)', opacity: 0 }),
                animate(
                    '300ms ease-out',
                    style({ transform: 'translateX(0)', opacity: 1 })
                ),
            ]),
            // Slide out to left
            transition(':leave', [
                style({ transform: 'translateX(0)', opacity: 1 }),
                animate(
                    '300ms ease-out',
                    style({ transform: 'translateX(-100%)', opacity: 0 })
                ),
            ]),
            // Slide states for direction-aware animations
            state(
                'current',
                style({
                    transform: 'translateX(0)',
                    opacity: 1,
                })
            ),
            state(
                'right',
                style({
                    transform: 'translateX(100%)',
                    opacity: 0,
                })
            ),
            state(
                'left',
                style({
                    transform: 'translateX(-100%)',
                    opacity: 0,
                })
            ),
            // Transitions between states
            transition('right => current', [animate('300ms ease-out')]),
            transition('current => left', [animate('300ms ease-out')]),
            transition('left => current', [animate('300ms ease-out')]),
            transition('current => right', [animate('300ms ease-out')]),
        ]),
    ],
})

export class ProductStepsComponent implements OnInit {
    @Input() showBanks: boolean = false;
    @Input() disableMatchingProductsBtn: boolean = false;
    @Input() IsDGPSteps: boolean = false;
    @Input() isAboutUs: boolean = false;
    @Output() clickEligibility: EventEmitter<any> = new EventEmitter<any>();
    @Input() selectedLanguage: string;
    isMobile = false;
    steps: { step: string; stepBM: string; title: string; titleBM: string; description: string; descriptionBM: string; icon: string }[];
    dgpSteps: { step: string; stepBM: string; title: string; titleBM: string; description: string; descriptionBM: string; icon: string }[];
    aboutUsSteps: { step: string; stepBM: string; title: string; titleBM: string; description: string; descriptionBM: string; icon: string }[];
    currentSlide: number = 0;
    windowWidth = window.innerWidth;
    activeIndex = 0;
    slideDirection = 'none'; // 'left', 'right', or 'none'

    touchStartX = 0;
    touchEndX = 0;
    constructor() {
        this.steps = [
            {
                // id: 1,
                step: 'Step 1',
                stepBM: 'Langkah 1',
                title: 'Register & Log In to imSME',
                titleBM: 'Daftar & Log Masuk ke imSME',
                description:
                    'Create an account and log in to submit your referral details.',
                icon: 'assets/images/icons/Money.png',
                descriptionBM:"Cipta akaun dan log masuk untuk menghantar butiran rujukan anda.",
            },
            {
                // id: 2,
                step: 'Step 2',
                stepBM: 'Langkah 2',
                title: 'Provide Business & Financial Information',
                titleBM: 'Berikan Maklumat Perniagaan & Kewangan',
                description:
                    'Complete the online application with the necessary details and supporting documents.',
                icon: 'assets/images/icons/Briefcase.png',
                descriptionBM:"Lengkapkan permohonan dalam talian dengan maklumat serta dokumen sokongan yang diperlukan.",
            },
            {
                // id: 3,
                step: 'Step 3',
                stepBM: 'Langkah 3',
                title: 'Get Instant Matching with Financial Partners',
                titleBM: 'Padanan Segera dengan Rakan Kewangan',
                description:
                    'Your application will be matched based on eligibility, connecting you to trusted financial institutions.',
                icon: 'assets/images/icons/ShoppingBagOpen.png',
                descriptionBM:"Permohonan anda akan dipadankan berdasarkan kelayakan, menghubungkan anda dengan institusi kewangan yang dipercayai.",
            },
            {
                // id: 4,
                step: 'Step 4',
                stepBM: 'Langkah 4',
                title: 'Referral to Financial Partners',
                titleBM: 'Rujukan kepada Rakan Kewangan Rakan Pembiayaan',
                description:
                    'Your selected financing partner will receive your application and respond within 48 hours.',
                icon: 'assets/images/icons/File.png',
                descriptionBM:"Pilihan anda akan menerima permohonan dan memberikan maklum balas dalam tempoh 48 jam.",
            },
        ];
        this.dgpSteps = [
            {
                // id: 1,
                step: 'Step 1',
                stepBM: 'Langkah 1',
                title: 'Register & Log In to imSME',
                titleBM: 'Daftar & Log Masuk ke imSME',
                description:
                    'Register on the imSME platform',
                icon: 'assets/images/icons/Money.png',
                descriptionBM:"Daftar di platform imSME",
            },
            
            {
                // id: 2,
                step: 'Step 2',
                stepBM: 'Langkah 2',
                title: 'Provide Business & Financial Information',
                titleBM: 'Berikan Maklumat Perniagaan & Kewangan',
                description:'Submit your financing application & Get Matched with suitable financial institutions',
                icon: 'assets/images/icons/Briefcase.png',
                descriptionBM:"Hantar permohonan pembiayaan anda & Dapatkan Padanan dengan institusi kewangan yang sesuai",
            },
            {
                // id: 3,
                step: 'Step 3',
                stepBM: 'Langkah 3',
                title: 'Get Instant Matching with Financial Partners',
                titleBM: 'Padanan Segera dengan Rakan Kewangan',
                description:
                    'Digital Guarantee Issued by CGC Digital to support your application',
                icon: 'assets/images/icons/ShoppingBagOpen.png',
                descriptionBM:"Jaminan Digital dikeluarkan oleh CGC Digital untuk menyokong permohonan anda",
            },
            {
                // id: 4,
                step: 'Step 4',
                stepBM: 'Langkah 4',
                title: 'Referral to Financial Partners',
                titleBM: 'Rujukan kepada Rakan Kewangan Rakan Pembiayaan',
                description:
                    'Receive Financing upon approval by the financial institution',
                icon: 'assets/images/icons/File.png',
                descriptionBM:"Terima Pembiayaan selepas diluluskan oleh institusi kewangan",
            },
        ];
        this.aboutUsSteps = this.steps;
    }

    ngOnInit(): void {
        this.checkIfMobile();
    }

    ngOnDestroy(): void {}

    @HostListener('window:resize')
    checkIfMobile(): void {
        this.isMobile = window.innerWidth < 768;
    }
    
    @HostListener('touchstart', ['$event'])
    onTouchStart(event: TouchEvent): void {
        this.touchStartX = event.touches[0].clientX;
    }

    @HostListener('touchend', ['$event'])
    onTouchEnd(event: TouchEvent): void {
        this.touchEndX = event.changedTouches[0].clientX;
        this.handleSwipe();
    }

    handleSwipe(): void {
        const swipeThreshold = 50;
        if (this.touchStartX - this.touchEndX > swipeThreshold) {
            // Swipe left (next)
            if (this.activeIndex < this.steps.length - 1) {
                this.goToNext();
            }
        } else if (this.touchEndX - this.touchStartX > swipeThreshold) {
            // Swipe right (previous)
            if (this.activeIndex > 0) {
                this.goToPrevious();
            }
        }
    }

    goToNext(): void {
        if (this.activeIndex < this.steps.length - 1) {
            this.slideDirection = 'left';
            this.activeIndex++;
        }
    }

    goToPrevious(): void {
        if (this.activeIndex > 0) {
            this.slideDirection = 'right';
            this.activeIndex--;
        }
    }

    setActiveIndex(index: number): void {
        if (index !== this.activeIndex) {
            this.slideDirection = index > this.activeIndex ? 'left' : 'right';
            this.activeIndex = index;
        }
    }

    getSlideState(index: number): string {
        if (index === this.activeIndex) {
            return 'current';
        }

        // For animation purposes only - these items aren't actually displayed
        // but the animation system needs to know the direction
        return index < this.activeIndex ? 'left' : 'right';
    }

    onClickEligibility(){
        this.clickEligibility.emit();
    }
}
